"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var link_1 = __importDefault(require("~/helpers/link"));
var _1 = __importDefault(require("~/helpers/$"));
var retry_1 = __importDefault(require("~/helpers/retry"));
function handleExternalLink(href, el) {
    if (el.dataset.local === 'true') {
        // REX books open in the current window; track them
        document.location.href = href;
    }
    else {
        var newWindow = window.open(href, '_blank');
        if (newWindow === null) {
            document.location.href = href;
        }
    }
}
function useLinkHandler() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var navigateTo = (0, react_1.useCallback)(function (path, state) {
        if (state === void 0) { state = { x: 0, y: 0 }; }
        navigate(link_1.default.stripOpenStaxDomain(path), state);
    }, [navigate]);
    var linkHandler = (0, react_1.useCallback)(
    // eslint-disable-next-line complexity
    function (e) {
        // Only handle left-clicks on links
        var el = link_1.default.validUrlClick(e);
        if (!el || e.button !== 0) {
            return;
        }
        e.preventDefault();
        var fullyQualifiedHref = el.href;
        var followLink = el.target || link_1.default.isExternal(fullyQualifiedHref)
            ? function () { return handleExternalLink(fullyQualifiedHref, el); }
            : function () { return navigateTo(fullyQualifiedHref); };
        // Pardot tracking
        if ('piTracker' in window && window.piTracker instanceof Function) {
            window.piTracker(fullyQualifiedHref.split('#')[0]);
        }
        if (e.trackingInfo) {
            (0, retry_1.default)(function () {
                return fetch("".concat(_1.default.apiOriginAndOldPrefix, "/salesforce/download-tracking/"), {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(e.trackingInfo)
                });
            })
                .catch(function (err) {
                throw new Error("Unable to download-track: ".concat(err));
            })
                .finally(followLink);
        }
        else {
            followLink();
        }
    }, [navigateTo]);
    return linkHandler;
}
exports.default = useLinkHandler;
